module.exports = __webpack_public_path__ + "static/img/ff74700.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/3.png
// module id = 607
// module chunks = 2